export default function isLinkAnEmail(linkText: string | null): boolean {
    if (!linkText) return false;
    if (!linkText.includes('@')) return false; // every email needs an @
    if (linkText.includes('/')) return false; // some URLs have an @ in them (eg mastodon links)
    return true;
}
